export default "__VITE_ASSET__DRhg$DIX__"